export const updateLayers = (map, layers) => {
    const {all, showing} = layers;
    if (all.length) {
        all.forEach(layerName => {
            map.setLayoutProperty(layerName, "visibility", showing.includes(layerName) ? "visible" : "none")
        })
    }
}